import type { NextPage } from 'next'
// import { useRouter } from 'next/router'
// import Link from 'next/link'
// import { useState } from 'react'

// import type { Item } from '@/modules/project'
import Dayjs from '@/components/dayjs'
import style from './item.module.css'

import AttachFileTable from './AttachFileTable'
import {EnvironmentalImpactDocument} from "@/modules/project";
import BlankPage from "@/components/pages/project/blank";


interface IProps {
  className?: string
  item?: EnvironmentalImpactDocument
}

const Component: NextPage<IProps> = ({ className , item}) => {
  const title = "사후환경영향조사";
  return (
    <section className={className || ''}>
      <h3 className={style.h3}>
        {title}
      </h3>
      {
        item && item.idx?
            (
                <>
                  <div>
                    <table className={`${style.baseInfoTable} border-t-2 border-t-gg-blue`}>
                      <colgroup>
                        <col width={200}/>
                        <col width={400}/>
                        <col width={200}/>
                        <col width={400}/>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th>조사년도</th>
                        <td><Dayjs format="YYYY">{item?.surveyDatetime}</Dayjs></td>
                        <th>환경영향조사기간</th>
                        <td><Dayjs format="dateDot">{item?.surveyStartDatetime}</Dayjs> ~ <Dayjs format="dateDot">{item?.surveyEndDatetime}</Dayjs></td>
                      </tr>
                      <tr>
                        <th>사후환경조사서</th>
                        <td colSpan={3} className='px-8 py-8'>
                          <div>
                            <table className="w-full table-auto">
                              <tbody>
                              <tr>
                                <th className='w-[160px] h-[60px] text-[18px] text-[#111111] font-medium align-middle bg-[#F7F7F7] border-t border-t-[#DDDDDDD]'>업체명</th>
                                <td colSpan={3} className='text-[18px] text-[#333333] font-light align-middle px-6 border-t border-t-[#DDDDDDD]'>{item?.investigatorBusinessName}</td>
                              </tr>
                              <tr>
                                <th className='w-[160px] text-[18px] text-[#111111] font-medium h-[60px] align-middle bg-[#F7F7F7] border-t border-t-[#DDDDDDD]'>대표자명</th>
                                <td className='w-[308px] text-[18px] text-[#333333] font-light align-middle px-6 border-t border-t-[#DDDDDDD]'>{item?.investigatorName}</td>
                                <th className='w-[160px] text-[18px] text-[#111111] font-medium h-[60px] align-middle bg-[#F7F7F7] border-t border-t-[#DDDDDDD]'>Mail</th>
                                <td className='w-[308px] text-[18px] text-[#333333] font-light align-middle px-6 border-t border-t-[#DDDDDDD]'>{item?.investigatorEmail}</td>
                              </tr>
                              <tr>
                                <th className='w-[160px] text-[18px] text-[#111111] font-medium h-[60px] align-middle bg-[#F7F7F7] border-t border-t-[#DDDDDDD] border-b border-b-[#DDDDDDD]'>팩스번호</th>
                                <td className='w-[308px] text-[18px] text-[#333333] font-light align-middle px-6 border-t border-t-[#DDDDDDD] border-b border-b-[#DDDDDDD]'>{item?.investigatorFax}</td>
                                <th className='w-[160px] text-[18px] text-[#111111] font-medium h-[60px] align-middle bg-[#F7F7F7] border-t border-t-[#DDDDDDD] border-b border-b-[#DDDDDDD]'>전화번호</th>
                                <td className='w-[308px] text-[18px] text-[#333333] font-light align-middle px-6 border-t border-t-[#DDDDDDD] border-b border-b-[#DDDDDDD]'>{item?.investigatorTelephone}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>공개동의 여부</th>
                        <td>{item?.isInvestigatorDisplay? "동의": "미동의"}</td>
                        <th>사업공정률(%)</th>
                        <td>100%</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='my-8'>
                    <AttachFileTable items={item?.files? item.files: []}/>
                  </div>
                </>
            )
            :
            (
                <BlankPage title={title} className="mb-12" />
            )
      }
    </section>
  )
}

export default Component
